var _path, _path2, _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedback1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3333 31C38.3333 35.0428 35.0428 38.3333 31 38.3333C26.9572 38.3333 23.6667 35.0428 23.6667 31C23.6667 26.9572 26.9572 23.6667 31 23.6667C35.0428 23.6667 38.3333 26.9572 38.3333 31Z",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 54.2555C15.6667 47.9594 18.4293 42.2655 23.006 38.9791C25.3143 41.1185 28.1163 42.2652 31.1071 42.2652C34.098 42.2652 36.9007 41.1186 39.2091 38.9791C43.7849 42.2648 46.5476 47.9593 46.5476 54.2555C46.5476 54.2926 46.5383 54.3184 46.5301 54.3334H15.6844C15.6761 54.3184 15.6667 54.2926 15.6667 54.2555Z",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 1.33333
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 54.9325,
    y1: 17,
    x2: 39.0069,
    y2: 17,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 24.4285,
    x2: 41.0863,
    y2: 24.4285,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 31.8571,
    x2: 46.3908,
    y2: 31.8571,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 39.2858,
    x2: 49.9272,
    y2: 39.2858,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback1);
export default __webpack_public_path__ + "static/media/Feedback1.efd22d0e7c21a75b4a951f2f22234532.svg";
export { ForwardRef as ReactComponent };